import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { components } from './';
import { DateTimeConverterPipe } from './date.pipe';
//Modals
import { AdvanceSearchModalComponent, AdvanceSearchUserModalComponent } from './modals';

@NgModule({
	imports: [ SharedModule ],
	declarations: [ components(), DateTimeConverterPipe, AdvanceSearchUserModalComponent, AdvanceSearchModalComponent ],
	entryComponents: [ AdvanceSearchModalComponent, AdvanceSearchUserModalComponent ],
	exports: [ components() ]
})
export class NgxFilterModule {}
